import dayjs from "dayjs";
import { useRef, useState } from "react";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import copy from "copy-to-clipboard";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../assets/icons/Spinner";
import TrashIcon from "../../../assets/icons/TrashIcon";

import Message from "../../../i18n/Message";
import { linkToForms } from "../../../routes";
import WorkspaceLayout from "../../shared/layout/WorkspaceLayout";

import FormSubmissionList from "./submission/FormSubmissionList";

import "./FormDetailsPage.scss";
import { formSelectors } from "../store/formReducer";
import {
  deleteForm,
  loadForm,
  loadFormSubmissions,
} from "../store/formActionCreators";
import FormPreviewContainer from "./preview/FormPreviewContainer";
import ExternalLinkIcon from "../../../assets/icons/ExternalLinkIcon";
import Edit2Icon from "../../../assets/icons/Edit2Icon";
import EditFormDialog from "../list/EditFormDialog";
import Notify from "../../shared/Notify";
import label from "../../../i18n/label";

const FormDetailsPage = () => {
  const { formId, workspaceId } = useParams();
  const intl = useIntl();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const form = useSelector(formSelectors.getForm);
  const submissionsCounter = useSelector(formSelectors.getSubmissionsCounter);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showShareConfirm, setShowShareConfirm] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const shareInputRef = useRef();

  useEffect(() => {
    if (!form || form?.uid !== formId) {
      dispatch(loadForm(intl, workspaceId, formId));
    }
  }, [form, formId, workspaceId, dispatch, intl]);

  useEffect(() => {
    if (showShareConfirm) {
      shareInputRef.current?.select();
    }
  }, [showShareConfirm, shareInputRef]);

  useEffect(() => {
    dispatch(loadFormSubmissions(intl, workspaceId, formId));
  }, [formId, submissionsCounter, workspaceId, dispatch, intl]);

  const onDeleteConfirmed = () => {
    const onSuccess = () => {
      setShowDeleteConfirm(false);
      nav(linkToForms(workspaceId));
    };
    dispatch(
      deleteForm(intl, workspaceId, formId, onSuccess, () =>
        setShowDeleteConfirm(false)
      )
    );
  };

  const onCopyLink = () => {
    copy(shareInputRef.current.value);
    Notify.success(label(intl, "share_form_copy_link_success"));
    setShowShareConfirm(false);
  };
  console.log("Form", form, form?.uid === formId);
  const item = !!form && form?.uid === formId ? form : null;

  return (
    <WorkspaceLayout contentPanelClassName="form_details_main">
      {!item && (
        <div className="spinner_container">
          <Spinner />
        </div>
      )}
      {item && (
        <>
          <div className="title_row card">
            <div className="title_top_panel">
              <div className="title_column">
                <div className="campaign_title">{item.name}</div>
                <div className="metadata_row">
                  <div>{item.description}</div>
                </div>
                <div className="metadata_row">
                  <div className="meta_name">
                    <Message id="created_on" />
                  </div>
                  <div className="meta_value">
                    {dayjs(item.dateCreated).format("LLL")}
                  </div>
                </div>

                {/*
              <div>
                <ToggleSwitch
                  onChange={onStatusChanged}
                  value={status}
                  optionLeft={{ label: "campaign_offline", value: "DRAFT" }}
                  optionRight={{ label: "campaign_online", value: "ONLINE" }}
                />
              </div>
      */}
              </div>
              <div className="title_actions">
                <div className="confirm_container">
                  {showDeleteConfirm && (
                    <>
                      <div
                        className="cover"
                        onClick={() => setShowDeleteConfirm(false)}
                      ></div>
                      <div className="confirm_panel">
                        <button
                          className="btn bg-gradient-primary btn-sm"
                          onClick={onDeleteConfirmed}
                        >
                          <Message id="confirm_delete" />
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <button
                  className="btn no-btn tile-action"
                  onClick={() => setShowDeleteConfirm(!showDeleteConfirm)}
                >
                  <TrashIcon size="16" color="#344767" />
                  <Message id="delete" />
                </button>
                <button
                  className="btn no-btn tile-action"
                  onClick={() => setShowEdit(true)}
                >
                  <Edit2Icon size="16" color="#344767" />
                  <Message id="edit" />
                </button>
                <button
                  className="btn btn-outline-secondary tile-action"
                  onClick={() => setShowShareConfirm(!showDeleteConfirm)}
                >
                  <ExternalLinkIcon size="16" color="#344767" />
                  <Message id="share_form" />
                </button>
                <div className="share_container">
                  {showShareConfirm && (
                    <>
                      <div
                        className="cover"
                        onClick={() => setShowShareConfirm(false)}
                      ></div>
                      <div className="confirm_panel">
                        <div>
                          <input
                            type="text"
                            readOnly
                            className="form-control"
                            ref={shareInputRef}
                            value={
                              window.location.protocol +
                              "//" +
                              window.location.host +
                              "/app/f/" +
                              workspaceId +
                              "/" +
                              form?.sharedUid
                            }
                          />
                        </div>
                        <button className="btn btn-sm" onClick={onCopyLink}>
                          <Message id="copy" />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <FormPreviewContainer form={form} />
          <FormSubmissionList form={form} />
          {/*
  
          <CampaignSubmissions campaign={campaign} submissions={submissios} />
                */}
        </>
      )}
      {showEdit && (
        <EditFormDialog form={form} onClose={() => setShowEdit(false)} />
      )}
    </WorkspaceLayout>
  );
};

export default FormDetailsPage;
